export const backendBaseUrl = "https://eqarcom-gateway-api.agp-dev.com";
export const backendIntegrationBaseUrl = "";
export const dashboardBaseUrl = "https://eqarcom-dashboard-api.agp-dev.com";

